import api from './api';

export const getCsrfToken = async () => {
    await api.getSecure('/csrfToken');
};
